<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header" style="position: relative;">
            <slot name="header">
              <h4>{{src.substring(0, 100)}}...</h4>
           
             <button type="link" v-focus
                style="position: absolute; top:15px; right:15px; border: 0 none;"
                class="btn btn-default btn-lg" 
                @click="$emit('cancel')"
                @keyup.esc="$emit('cancel')"
                title="Fenster schließen">
                <span class="glyphicon glyphicon-remove" aria-hidden="true"></span>
            </button>

            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form v-focus @keyup.esc="$emit('cancel')" @submit.prevent="submit" :id="_uid" > 
              
                <iframe id=""
                  name="" 
                  :src="src"
                  width="100%" height="800px" marginheight="0" marginwidth="0" frameborder="0" scrolling="Yes"
                  style="height: 80vh"
                >
                </iframe>
                
              </form>
            </slot>
          </div>
<!--
          <div class="modal-footer">
            <slot name="footer">
               
              <button type="submit"
                :form="_uid"
                class="btn btn-primary">
                Speichern
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('cancel')">
                close
              </button>
              
            </slot>
          </div>
-->          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

import bus from './common/bus'

export default {
  
  
  components: {
  },  
  
  props: {
    content: '',
    type: '',
  },
  
  data () {
    return {
      src: '',
    }
  },
  
  mounted: function () {
  },
  
  created: function () {
    
    const a_content = _.trim(this.content).split(/ +/);
    let query = a_content[0];

    if(this.type == '11'){ // Web Download
        const idMainCallCenter = _.padStart(bus.cache.companyClient.idMainCallCenter, 6, '0');
        const idCompanyClient  = _.padStart(bus.cache.companyClient.id, 6, '0');
        query = (_.startsWith( query, "/")) ? query : "/" +  query;
        this.src = 'https://www.cc-vorgaben.de/upload2/index.php/' + idMainCallCenter + '/' + idCompanyClient + query + '?ccprontoid=' + bus.login.authBearer ;
        return;
    }

    if(this.type == '12'){ // Web Tabelle
        const idMainCallCenter = _.padStart(bus.cache.companyClient.idMainCallCenter, 6, '0');
        const idCompanyClient  = _.padStart(bus.cache.companyClient.id, 6, '0');
        query = (_.startsWith( query, "/")) ? query : "/" +  query;
        this.src = 'https://www.cc-vorgaben.de/tabelle2/index.php/' + idMainCallCenter + '/' + idCompanyClient + query +'?ccprontoid=' + bus.login.authBearer ;;
        return;
    }
    
    // default
    this.src = (_.startsWith( query, "http")) ? query : "https://" +  query;
    return;
    
  },
  
  computed: {
    
  },  
  
  
  methods: {
    
  },
}
  
</script>



<style scoped>

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .3);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  padding-top: 70px;
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  
  width: 96%;
  height: auto;
  margin: 0px auto;
  padding: 0px 0px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  margin: 0px 0;
}

.modal-footer {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

input:invalid {
  border: 1px solid red;
}  

</style>



// WEBPACK FOOTER //
// ExternSite.vue?705709c6